import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, ValidationErrors } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { StationService } from 'src/app/services/station.service';
import { EmployeeService } from 'src/app/services/employee.service';
import { NotifierService } from 'angular-notifier';
import { NgxSpinnerService } from 'ngx-spinner';
import { ReservationService } from 'src/app/services/reservation.service';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-add-promo-service',
  templateUrl: './add-promo-service.component.html',
  styleUrls: ['./add-promo-service.component.scss']
})
export class AddPromoServiceComponent implements OnInit {
  minDate = new Date();
  showForm = true;
  today = moment().format('MM/DD/YYYY');
  contractTypes :any;
  formTitle = '';
  submitted = false;
  urlValue:any;
  showUrlBox = false;
  editPromo = false;
  selectedContractType: any;
  promoCodeValue:any
  promoForm !: FormGroup;
  statusTypes = [{
    id: false,
    name: "InActive"
  },
  {
    id: true,
    name: "Active"
  }
  ]

  public constructor(
    private notifier: NotifierService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private authService: AuthenticationService,
    private router: Router,
    private reservationService: ReservationService,
    private stationService: StationService,
    private employeeService: EmployeeService,
    private authenticationService: AuthenticationService) {
  }

  ngOnInit() {
    this.getAllContractTypes();
    if (this.route.snapshot.paramMap.get('cid') != null && this.route.snapshot.paramMap.get('sid') != null) {
      // this.formTitle = "Update Contract Service";
      this.editPromo = true;
      // this.contractByStationId = this.route.snapshot.paramMap.get('cid');
      // this.contractServicesId = this.route.snapshot.paramMap.get('sid');
      // this.getContractServiceByIDs(this.route.snapshot.paramMap.get('cid'), this.route.snapshot.paramMap.get('sid'));
    } else {
      this.formTitle = "Add Promotional Services"
    }
    this.initAddPromoForm();
  }

  backToPromoServices() {
    // this.location.back();
    this.router.navigateByUrl("home/promo-services");
  }
  initAddPromoForm() {
    let st = moment().format('MM/DD/YYYY');
    this.promoForm = new FormGroup({
      contractID: new FormControl('', Validators.compose([Validators.required,this.customValidation])),
      discount_percent: new FormControl('', Validators.compose([Validators.required])),
      contractType: new FormControl(''),
      active: new FormControl(true, Validators.compose([Validators.required])),
      effectsDate: new FormControl(st, Validators.compose([Validators.required])),
      description : new FormControl('')
    });
  }
  get promoFormcontrols() { return this.promoForm.controls; }
  getAllContractTypes(){
    this.reservationService.getContractTypes().subscribe(res => {
      this.contractTypes = res['result'];
    });
  }
  amountChangeCheckingFn(event) {
    // console.log(event.value)
    //  if (event.value !== this.contractServicesData.service[0].AMOUNT) {
    //   // console.log("Amount Changed.........");
    //   // console.log('log');
    //    this.isAmountChanged = true;
    //  } else {
    //    this.isAmountChanged = false;
    //  }
   }
   validateContract() {
    //console.log("callingg...");
    if (this.promoFormcontrols.contractID.errors) {
      this.notifier.notify('warning', 'Please enter Contract ID');
      return false;
    }
    if (this.promoFormcontrols.contractType.errors) {
      this.notifier.notify('warning', 'Please select Contract Type ');
      return false;
    }
   
    if (this.promoFormcontrols.discount_percent.errors) {
      this.notifier.notify('warning', 'Please enter Discount');
      return false;
    }
  }
   onAddPromoContract(values) {
    this.submitted = true;
    this.validateContract();
    this.promoForm.markAllAsTouched();
    if (this.promoForm.invalid) {
      return;
    }
    if (! (moment(values.effectsDate).isSameOrAfter(moment(this.today)) ) ){
      this.notifier.notify('warning', 'Effective start date should be today or future date!');
      return false;
    }
    var data = {
      contractId: values.contractID.toUpperCase(),
      contractType: 'Retail',
      discount_percent: values.discount_percent,
      lcbId: this.authService.getCurrentUserId(),
      active: true,
      effectiveStartDate: moment(values.effectsDate).format('MM/DD/YYYY'),
      description : values.description
    }

    this.spinner.show()
    this.reservationService.insertPromoService(data).subscribe((res: any) => {
      if (res['status'] == true) {
        this.notifier.notify('success', res['message']);
        this.spinner.hide()
        this.submitted = false;
        this.showForm = false;
        this.displayUrl(this.promoForm.value.contractID)
        // this.router.navigateByUrl("home/promo-services");
      } else {
        this.submitted = false
        this.spinner.hide()
        this.notifier.notify('danger', res['message'])
      }
    }, err => {
      this.notifier.notify('danger', err.message)
      // console.log(err);
    })
  }
  get f(): any {
    return this.promoForm.controls;
  }
  validation_messages = {
    'contractID': [
      { type: 'required', message: 'Promo Code is required.' },
      { type: 'noSpaces', message: 'Spaces are not allowed in Promo Code.' },
      { type: 'noSpecialCharStart', message: 'Promo Code cannot start with a special character.' },
      { type: 'noSpecialChar', message: 'Promo Code can only contain alphanumeric characters and hyphens(-).' }
   
    ],
    'contractType': [
      { type: 'required', message: 'Contract Type is required.' }
    ],
    'discount_percent': [
      { type: 'required', message: 'Discount(%) is required.' }
    ],
    'active': [
      { type: 'required', message: 'Status is required.' }
    ],
    'effectsDate': [
      { type: 'required', message: 'Effective Date is required.' }
    ]

  }

  customValidation(control: FormControl): ValidationErrors | null {
    const value = control.value || '';
    // 1. Check if the value contains spaces
    const hasSpaces = value.includes(' ');
    // 2. Check if the first character is a special character
    const startsWithSpecialChar = /^[^a-zA-Z0-9]/.test(value); // Special char at the start
    // 3. Check for invalid special characters (anything except a hyphen `-`)
    const containsInvalidSpecialChar = /[^a-zA-Z0-9-]/.test(value); // Any non-alphanumeric, non-hyphen character
    // Return appropriate validation error if conditions are met
    if (hasSpaces) {
      return { noSpaces: true };
    }
    if (startsWithSpecialChar) {
      return { noSpecialCharStart: true };
    }
    if (containsInvalidSpecialChar) {
      return { noSpecialChar: true }; // Invalid special character (other than `-`)
    }
    return null; // No errors
  }
    // This method converts the input to uppercase
    convertToUpperCase(event: any): void {
      const input = event.target;
      input.value = input.value.toUpperCase(); // Convert the value to uppercase
    }
    displayUrl(code:any){
      let url = environment.url
      this.showUrlBox = false;
      if(code){
        this.showUrlBox = true;
        this.promoCodeValue = code.toUpperCase();
        this.urlValue = url+'/retail/'+code.toUpperCase();
      }
      else{
        this.showUrlBox = false;
        this.promoCodeValue = '';
        this.urlValue = ''
      }
    }
    copyToClipboard(url: string): void {
      navigator.clipboard.writeText(url).then(() => {
        this.notifier.notify('success', 'url copied.');
          // alert('URL copied to clipboard!');
      }).catch(err => {
          console.error('Failed to copy: ', err);
      });
  }
  
}
